import { HasNavigationTreeState } from "@insite/client-framework/Store/Data/NavigationTree/NavigationTreeState";

export function getNavigationTreeNode(state: HasNavigationTreeState, rootId: string | undefined) {
    return rootId ? state.data.navigationTree.treesByRootId[rootId] : undefined;
}

export function getNavigationTreeDepthLoaded(state: HasNavigationTreeState, rootId: string) {
    return state.data.navigationTree.loadedDepthByRootId[rootId] ?? 0;
}

export function getNavigationTreeIsLoading(state: HasNavigationTreeState, rootId: string) {
    return !!state.data.navigationTree.isLoadingByRootId[rootId];
}
